import React, { useState, useEffect } from "react";
import useExceptionHandler from "hooks/useExceptionHandler";
import { Button } from "react-bootstrap";
import { CompaniaManager } from "managers";
import useMessage from "hooks/useMessage";
import { Card, Form } from "react-bootstrap";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import useConfirm from "hooks/useConfirm";
import qbDefault from "assets/img/C2QB_green_btn_med_default.svg";
import qbHover from "assets/img/C2QB_green_btn_med_hover.svg";

const VincularCuentaQuickbooks = ({
  showLoading,
  hideLoading, }) => {

  const { handleException } = useExceptionHandler();
  const { Message, cerrarAlertas } = useMessage();
  const [companyInfo, setCompanyInfo] = useState(null);
  const { Confirm, Types } = useConfirm();

  useEffect(() => {
    showLoading();
    CompaniaManager.ObtenerInformacionCuentaQuickbooks()
      .then((res) => {
        setCompanyInfo(res.Data);
      })
      .catch((e) => {
        handleException(e)
      }).finally(() => hideLoading());;

    return () => { };
  }, []);


  const handleClickVincular = async () => {
    showLoading();
    try {
      await CompaniaManager.obtenerURLQuickbooks()
        .then((res) => {
          window.open(res.Data, "_blank", "noopener,noreferrer");
        })
        .catch((e) => {

          handleException(e)
        });

    } catch (error) {
      handleException(error)
    } finally {
      hideLoading();
    }
  };



  function showConfirm() {
    Confirm({
      type: Types.TYPE_DEFAULT,
      title: "Desvincular Cuenta de Quickbooks",
      textBody: "¿Esta seguro que desea desvincular esta cuenta de Quickbooks?",
      onConfirm: () => desvincularCuenta(),
      onCancel: () => { },
    });
  }

  const desvincularCuenta = () => {
    showLoading();

    CompaniaManager.devincularCuentaQuickbooks()
      .then((res) => {
        setCompanyInfo(null);
        Message({ message: `Cuenta Desvinculada Exitosamente` });
      })
      .catch((e) => {

        handleException(e)
      })
      .finally(() => hideLoading());
  };


  const [hoverVincular, setHoverVincular] = useState(false);

  return (
    companyInfo && companyInfo.CompanyName ? <>

      <EditSection title="Cuenta Vinculada:">
        <InputContainer label="Nombre Compania">
          <Form.Control
            name="NombreCompania"
            type="text"
            value={companyInfo.CompanyName}
            readOnly
          />
        </InputContainer>
        <InputContainer label="Razón Social">
          <Form.Control
            name="RazonSocialQb"
            type="text"
            value={companyInfo.LegalName}
            readOnly
          />
        </InputContainer>
        <InputContainer label="Email">
          <Form.Control
            name="EmailQb"
            type="text"
            value={companyInfo.Email}
            readOnly
          />
        </InputContainer>
      </EditSection>
      <Button
        variant="link"
        onClick={() => showConfirm()}
        style={{ padding: 0, fontSize: "0.9rem", color: "#4491f9" }}
      >
        Desvincular Cuenta de Quickbooks
      </Button>
    </> :
      <img
        src={hoverVincular ? qbHover : qbDefault}
        alt="Vincular Cuenta de Quickbooks"
        style={{ cursor: "pointer", height: "40px" }}
        onClick={() => handleClickVincular()}
        onMouseEnter={() => setHoverVincular(true)}
        onMouseLeave={() => setHoverVincular(false)}
      />
  );
};

export default VincularCuentaQuickbooks;
